import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { DreTipoRegimeTributario } from 'pages/financeiro/dre/configuracao/types';

export function DreTipoRegimeTributarioAutoComplete({ sx, name, value, error, size, disabled = false, onChange = () => {} }: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            label="Tipo de regime tributário"
            objectId="idTipoRegimeTributario"
            optionStringTemplate="{dsTipoRegimeTributario}"
            selectedStringTemplate="{dsTipoRegimeTributario}"
            sx={sx}
            size={size}
            name={name}
            value={value}
            error={error}
            onChange={onChange}
            disabled={disabled}
            multiple={false}
            isOptionEqualToValue={(option: DreTipoRegimeTributario, value: DreTipoRegimeTributario) =>
                option.idTipoRegimeTributario === value.idTipoRegimeTributario
            }
            requestOptions={{
                url: '/dre/tiporegimetributario',
                sort: [{ property: 'idTipoRegimeTributario', direction: 'ASC' }],
                nested: true,
            }}
        />
    );
}
